import { ApiTags, rootApi } from '../../../../services/rootApi';
import { IRelativeRedirectURL } from '../models';

const TAG = ApiTags.ServiceRequest;

const gatepassUrlsApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getRedirectUrl: builder.query<IRelativeRedirectURL, string>({
      query: (uniqueKey) => `/RelativeURl/${uniqueKey}`,
      providesTags: (result) => result ? [{ type: TAG, id: result.id }] : [TAG]
    })
  })
})

export const {
  useGetRedirectUrlQuery,
  useLazyGetRedirectUrlQuery
} = gatepassUrlsApi;